<template>
  <div class="border">
    <form @submit.prevent>
      <fields-list simple="1" :fields="fields" :item="item" />
      <p-button
        class="btn btn-info"
        type="info"
        @click.native.prevent="addItem"
      >
        <span class="ti-plus"></span>
        {{ "add" | setText("Добавить") }}</p-button
      >
    </form>
  </div>
</template>
<script>
import { errorNotify, multiKeyInit, cardUpdate } from "@/plugins/functions";

export default {
  created() {
    let item = {};
    this.fields = [];
    this.fields = this.fieldsFrom.slice();

    for (let i = 0; i < this.fields.length; i++) {
      item[this.fields[i].key] = "";
    }

    this.item = this.multiKeyInit(item, this, 0);
  },
  data() {
    return {
      item: {},
      fields: [],
    };
  },
  props: {
    setLink: {
      default: "",
    },
    cardLink: {
      default: "",
    },
    openItem: {
      default: true,
    },
    modalTitle: {
      default: "Новый элемент",
    },
    modalCreate: {
      default: "",
    },
    fieldsFrom: {
      type: Array,
      default: {
        function(prams) {
          return [];
        },
      },
    },
    onCreateOpen: {
      default: true,
    },
    getList: {
      default: function () {
        return false;
      },
    },
  },
  methods: {
    multiKeyInit: multiKeyInit,
    errorNotify: errorNotify,
    cardUpdate: cardUpdate,

    async addItem() {
      let item = await this.cardUpdate(
        this.setLink,
        this.item,
        this.fields,
        "POST"
      );
      if (item && item.id) {
        if (this.openItem === true) {
          let query = Object.assign({}, this.$route.query);
          if (query[this.cardLink]) {
            delete query[this.cardLink];
          }
          query[this.cardLink] = item.id;
          setTimeout(() => {
            this.$router.replace({ query: query });
          }, 20);
        }
      }
    },
  },
};
</script>